import cx from "classnames";
function OverlayButton({ onClick, open }) {
  return (
    <button
      type="button"
      className={cx(
        "fixed bottom-0 left-0 right-0 top-0 z-40 h-screen cursor-default rounded-none border-none -indent-[999px] text-[0px] transition-all delay-300 duration-300",
        {
          "w-full bg-[#0000004D] opacity-100": open,
          "opacity-0": open,
        }
      )}
      name="closeOutside"
      onClick={onClick}
      aria-label="Close overlay"
    >
      Close
    </button>
  );
}

export default OverlayButton;
